export async function registerModule(register, runtime, context) {
    await register(runtime, context);
}
